// 채팅 기능 토글·모델·권한 상태(독립) + 마운트 시 me/models/공지/사용량 로드.
import { useState, useEffect } from 'react';
import { chatAPI, authAPI } from '../../../api/client';
import { canSeeMenu } from '../../../utils/menuAccess';
import { supportsReasoning } from '../../../utils/modelCaps';

export default function useChatFeatures() {
  const [webSearch, setWebSearch]         = useState(() => localStorage.getItem('chatWebSearch') === '1');
  const [reasoning, setReasoning]         = useState(() => localStorage.getItem('chatReasoning') === '1');
  const [internalData, setInternalData]   = useState(() => localStorage.getItem('chatInternalData') === '1');       // 사내데이터(WMS/주문/재고 조회) 모드
  const [useRag, setUseRag]               = useState(() => localStorage.getItem('chatUseRag') === '1');        // 문서 기반 답변(RAG): 사내 학습자료 검색 주입
  const [ragSources, setRagSources]       = useState(null);         // {convId, list} 최근 답변의 참고 문서 출처
  const [dbAccess, setDbAccess]           = useState(() => { const u = JSON.parse(localStorage.getItem('user') || '{}'); return !!u.db_access || u.role === 'admin'; });  // 사내데이터 권한
  const [internalLan, setInternalLan]     = useState(true);        // 사내망 요청 여부(외부면 사내데이터 토글 숨김)
  const [driveAccess]                     = useState(() => { try { return canSeeMenu(JSON.parse(localStorage.getItem('user') || '{}'), 'drive'); } catch (e) { return false; } });  // 드라이브 접근권한(첨부 버튼 게이트)
  const [models, setModels]               = useState([]);        // 허용 모델 [{id,label}]
  const [selectedChatModel, setSelectedChatModel] = useState(() => localStorage.getItem('chatModel') || '');
  const [showDrivePicker, setShowDrivePicker] = useState(false);
  const [, setMyUsage] = useState({ used: 0, limit: 0 });   // 사용량 fetch만(표시는 AppSidebar) — getter 미사용
  const [, setAnnouncements] = useState([]);   // fetch만(표시는 Announcements 컴포넌트) — getter 미사용

  const refreshMyUsage = () => chatAPI.getMyUsage().then((r) => setMyUsage(r.data)).catch(() => {});

  useEffect(() => { localStorage.setItem('chatWebSearch', webSearch ? '1' : '0'); }, [webSearch]);
  useEffect(() => { localStorage.setItem('chatReasoning', reasoning ? '1' : '0'); }, [reasoning]);
  useEffect(() => { localStorage.setItem('chatInternalData', internalData ? '1' : '0'); }, [internalData]);
  useEffect(() => { localStorage.setItem('chatUseRag', useRag ? '1' : '0'); }, [useRag]);
  useEffect(() => { if (selectedChatModel) localStorage.setItem('chatModel', selectedChatModel); }, [selectedChatModel]);
  useEffect(() => {
    // 🔴 이 이펙트가 Fable 을 되돌리고 있었다 — 토글은 열리는데 눌러도 즉시 OFF 였다.
    //    판정은 utils/modelCaps 하나로 모았다(백엔드가 내려준 능력을 쓴다).
    if (reasoning && selectedChatModel && models.length && !supportsReasoning(models, selectedChatModel)) {
      setReasoning(false);
    }
  }, [reasoning, selectedChatModel, models]);

  useEffect(() => {
    chatAPI.getAnnouncements().then((r) => setAnnouncements(r.data)).catch(() => {});
    refreshMyUsage();
    authAPI.getMe().then((r) => {
      const canDb = !!r.data.db_access || r.data.role === 'admin';
      const lan = r.data.internal_lan !== false;
      setDbAccess(canDb);
      setInternalLan(lan);
      if (!(canDb && lan)) setInternalData(false);
    }).catch(() => {});
    chatAPI.getModels().then((r) => {
      const list = r.data.models || [];
      setModels(list);
      setSelectedChatModel((prev) => (prev && list.some((m) => m.id === prev)) ? prev : (r.data.default || list[0]?.id || ''));
    }).catch(() => {});
  }, []);

  return {
    webSearch, setWebSearch, reasoning, setReasoning, internalData, setInternalData, useRag, setUseRag, ragSources, setRagSources,
    dbAccess, internalLan, driveAccess, models, selectedChatModel, setSelectedChatModel,
    showDrivePicker, setShowDrivePicker, refreshMyUsage,
  };
}
